<template>
  <div>
    <AppHeader />
    <div class="container">
      <div class="row mt-5">
        <div class="col-md-4 px-2">
          <div class="card">
            <div class="card-body">
              <h3>New Entry</h3>
                <div>
                  <div class="form-group">
                    <label for="name">Name</label>
                    <vue-bootstrap-typeahead 
                      id="name" 
                      ref="name"
                      type="text" 
                      v-model="form.name"
                      :data="names"
                      placeholder="Enter name"
                    />
                  </div>
                  <div class="form-group">
                    <label for="company">Company</label>
                    <vue-bootstrap-typeahead 
                      id="company" 
                      type="text" 
                      ref="company"
                      :data="companies"
                      v-model="form.company"
                      placeholder="Enter company"
                    />
                  </div>
                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="minutes">Minutes</label>
                        <input 
                          id="minutes" 
                          type="number" 
                          class="form-control" 
                          v-model.number="form.minutes"
                          placeholder="Enter minutes"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="seconds">Seconds</label>
                        <input 
                          id="seconds" 
                          type="number"
                          v-model.number="form.seconds" 
                          class="form-control" 
                          placeholder="Enter seconds"
                        />
                      </div>
                    </div>
                  </div>
                  <button class="btn btn-primary btn-block" @click="addParticipant">Save Changes</button>
                </div>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-body">
              <div class="card-title">Pause/Resume Slide Presentation</div>
              <button 
                :class="`btn btn-block btn-${shouldPlaySlide ? 'success' : 'secondary'}`" 
                @click="togglePauseResumeSlide"
              >
                <i :class="`fa fa-${shouldPlaySlide ? 'pause' : 'play'}`"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-8 px-2">
          <div class="card">
            <div class="card-body">
              <h3>Rankings Preview</h3>
              <div class="ranking-card">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Rank</th>
                      <th scope="col">Name</th>
                      <th scope="col">Company</th>
                      <th scope="col">Time</th>
                      <th scope="col">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in rankings" :key="item.id">
                      <th scope="row">{{ index+1 }}</th>
                      <td>{{ item.name }}</td>
                      <td>{{ item.company }}</td>
                      <td>{{ item.minutes }}mins/{{ item.seconds }}secs</td>
                      <td>
                        <button class="btn btn-sm" @click="deletePerson(item.id)">
                          <i class="fa fa-close text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '../../Layouts/AppHeader';
import { db, rankingsCollection, flashSettingsCollection } from '../../config/firebase';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

export default {
  name: 'RankingSettings',
  components: { AppHeader, VueBootstrapTypeahead },
  data() {
    return {
      rankings: [],
      form: {
        name: '',
        company: '',
        minutes: 0,
        seconds: 0
      },
      flashSettings: []
    }
  },
  firestore: {
    rankings: rankingsCollection.orderBy('minutes').orderBy('seconds'),
    flashSettings: flashSettingsCollection
  },
  computed: {
    names() {
      const names = this.rankings.map(item => item.name);
      return names.filter((item, index) => names.indexOf(item) == index);
    },
    companies() {
      const companies = this.rankings.map(item => item.company);
      return companies.filter((item, index) => companies.indexOf(item) == index);
    },
    shouldPlaySlide() {
      const defaultDoc = this.flashSettings[0];
      return defaultDoc ? defaultDoc.shouldPlaySlide : false;
    }
  },
  methods: {
    beforeInsert() {
      const doc = this.rankings.find(item => item.name == this.form.name && item.company == this.form.company);
      if (doc)
        return doc.id;
      else
        return 0;
    },

    addParticipant() {
      const { name, company, minutes, seconds } = this.form;
      if (!name || !company) {
        this.$toaster.error('Name and company is required!');
        return;
      }

      const docId = this.beforeInsert();
      if (docId) {
        rankingsCollection
        .doc(docId)
        .update(this.form)
        .then(() => {
          this.resetForm();
          this.$toaster.info('Time updated!');
        })
        .catch(error => {
          this.$toaster.error('Oops! Something went wrong. Please try again!');
        });
      } else {
        rankingsCollection
        .add(this.form)
        .then(() => {
          this.resetForm();
          this.$toaster.success('Successfully saved!');
        })
        .catch(error => {
          this.$toaster.error('Oops! Something went wrong. Please try again!');
        });
      }
    },

    resetForm() {
      this.form = {
        name: '',
        company: '',
        minutes: 0,
        seconds: 0
      }

      // vue-bootstrap-typeahead: are not reactive programmatically
      this.$refs.name.inputValue = '';
      this.$refs.company.inputValue = '';
    },

    deletePerson(id) {
      if (confirm('Are you sure to remove this?')) {
        rankingsCollection
        .doc(id)
        .delete()
        .then(() => {
          this.$toaster.success('Successfully removed!');
        })
        .catch(error => {
          this.$toaster.error('Oops! Something went wrong. Please try again!');
        });
      }
    },

    togglePauseResumeSlide() {
      flashSettingsCollection
      .doc('default')
      .update({
        shouldPlaySlide: this.shouldPlaySlide ? false : true
      })
      .then(() => {
        this.$toaster.success(`Slide has been ${this.shouldPlaySlide ? 'resumed' : 'paused'}`);
      })
      .catch(error => {
        this.$toaster.error('Oops! Something went wrong. Please try again!');
      });
    }
  }
}
</script>

<style scoped>
.ranking-card {
  min-height: 297px;
  max-height: 500px;
  overflow-y: auto;
}
</style>